import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InventoryRoutingModule } from './inventory-routing.module';
import { MainRoutingModule } from '@app/main/main-routing.module';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { SubheaderModule } from '@app/shared/common/sub-header/subheader.module';
import { FormsModule } from '@angular/forms';
import { Angular2CountoModule } from '@awaismirza/angular2-counto';
import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { BrandsComponent } from './brands/brands.component';
import { CreateOrEditBrandModalComponent } from './brands/create-or-edit-brand-modal.component';
import { CategoriesComponent } from './categories/categories.component';
import { CreateOrEditCategoryModalComponent } from './categories/create-or-edit-category-modal.component';
import { CreateOrEditDepartmentModalComponent } from './departments/create-or-edit-department-modal.component';
import { DepartmentsComponent } from './departments/departments.component';
import { CreateOrEditSubCategoryModalComponent } from './subCategories/create-or-edit-subCategory-modal.component';
import { SubCategoriesComponent } from './subCategories/subCategories.component';
import { CreateOrEditUnitModalComponent } from './units/create-or-edit-unit-modal.component';
import { UnitsComponent } from './units/units.component';
import { FileUploadModule } from 'primeng/fileupload';
import { AppSharedModule } from '@app/shared/app-shared.module';
import { PriceGroupsComponent } from './priceGroups/priceGroups.component';
import { CreateOrEditPriceGroupModalComponent } from './priceGroups/create-or-edit-priceGroup-modal.component';
import { ProductsComponent } from './products/products.component';
import { CreateOrEditProductComponent } from './products/create-or-edit-product.component';
import { DialogModule } from 'primeng/dialog';
import { AverageCostMovementComponent } from './reports/average-cost-movement/average-cost-movement.component';
import { DailyMovementComponent } from './reports/daily-movement/daily-movement.component';
import { DepartmentStockComponent } from './reports/department-stock/department-stock.component';
import { FifoExpiryComponent } from './reports/fifo-expiry/fifo-expiry.component';
import { InventoryAgingComponent } from './reports/inventory-aging/inventory-aging.component';
import { InventoryMovementComponent } from './reports/inventory-movement/inventory-movement.component';
import { InventoryAgingDetailComponent } from './reports/inventory-aging-detail/inventory-aging-detail.component';
import { InventoryPriceAuditTrailComponent } from './reports/inventory-price-audit-trail/inventory-price-audit-trail.component';
import { InventorySerialMovementComponent } from './reports/inventory-serial-movement/inventory-serial-movement.component';
import { InventoryStockComponent } from './reports/inventory-stock/inventory-stock.component';
import { InventoryStockByDateComponent } from './reports/inventory-stock-by-date/inventory-stock-by-date.component';
import { StockMovementComponent } from './reports/stock-movement/stock-movement.component';
import { ProductBatchSerialStockComponent } from './reports/product-batch-serial-stock/product-batch-serial-stock.component';
import { ProductMaterialsDetailComponent } from './reports/product-materials-detail/product-materials-detail.component';
import { ProductWeightComponent } from './reports/product-weight/product-weight.component';
import { PurchaseCostVariationLogComponent } from './reports/purchase-cost-variation-log/purchase-cost-variation-log.component';
import { StockActualQtyComponent } from './reports/stock-actual-qty/stock-actual-qty.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';


@NgModule({
  declarations: [
    SubCategoriesComponent,
    CreateOrEditSubCategoryModalComponent,
    UnitsComponent,
    CreateOrEditUnitModalComponent,
    BrandsComponent,
    CreateOrEditBrandModalComponent,
    DepartmentsComponent,
    CreateOrEditDepartmentModalComponent,
    CategoriesComponent,
    CreateOrEditCategoryModalComponent,
    PriceGroupsComponent,
    CreateOrEditPriceGroupModalComponent,
    ProductsComponent,
    CreateOrEditProductComponent,
    AverageCostMovementComponent,
    DailyMovementComponent,
    DepartmentStockComponent,
    FifoExpiryComponent,
    InventoryAgingComponent,
    InventoryMovementComponent,
    InventoryAgingDetailComponent,
    InventoryPriceAuditTrailComponent,
    InventorySerialMovementComponent,
    InventoryStockComponent,
    InventoryStockByDateComponent,
    StockMovementComponent,
    ProductBatchSerialStockComponent,
    ProductMaterialsDetailComponent,
    ProductWeightComponent,
    PurchaseCostVariationLogComponent,
    StockActualQtyComponent,

    
  ],
  imports: [
        CommonModule,
        FormsModule,
        ModalModule,
        TabsModule,
        TooltipModule,
      AppCommonModule,
      CardModule,
      MultiSelectModule,
      CalendarModule,
        UtilsModule,
        InventoryRoutingModule,
        AppSharedModule, 
        Angular2CountoModule,
        FileUploadModule,
        DialogModule,
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        SubheaderModule,
  ],
  providers: [
          { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
          { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
          { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
      ],
})
export class InventoryModule { }
